import { Media } from './media';
import { Lesson } from './lesson';
import { iCourseMeta } from '../interfaces/iCourseMeta';

export class Course {
    id: number;
    title: string;
    description: string;
    rating: number;
    points: number;
    media_id: number;
    media: Media;
    lessons: Lesson[];
    price:number;
    meta:iCourseMeta;
    quiz_id:number;
    tutors:any;
    supporters:any;
    streams:any;
    published;
    category;
    topics:string;
    documents:any;
    constructor(course?) {
        if (course) {
            this.id = course.id;
            this.title = course.title;
            this.description = course.description;
            this.media = course.media;
            this.rating = course.rating;
            this.points = course.points;
            this.media_id = course.media_id;
            this.lessons = course.lessons;
            this.price = course.price;
            this.quiz_id = course.quiz_id;
            this.tutors = course.tutors;
            this.supporters = course.supporters;
            this.streams= course.streams;
            this.published=course.published;
            this.category=course.category;
            this.topics=course.topics;
            this.documents=course.documents;
        }
    }
}
